import React from 'react';
import { ArcStack } from '@src/core/ui';
import { MissionTemplatesSidebar } from './sidebar';
import { MissionTemplatesContent } from './content';

const MissionTemplatesPage: React.FC = () => (
  <ArcStack direction='row'>
    <MissionTemplatesSidebar />
    <MissionTemplatesContent />
  </ArcStack>
);

export default MissionTemplatesPage;
